import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface RequireDetailsProps {
  field: Field
  onChange: (value: boolean) => void
}

const RequireDetails = ({ field, onChange }: RequireDetailsProps) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-require-details-input' }}>
    <Card.Title size="small" action={<TogglerCheckbox value={field.value} onChange={onChange} />}>
      {i18n.t('settings.leave_types.page.permissions.form.require_details.label')}
    </Card.Title>
    <Card.Description>
      {i18n.t('settings.leave_types.page.permissions.form.require_details.description')}
    </Card.Description>
  </Card>
)

export default RequireDetails
